import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled, { Box } from '@xstyled/styled-components';
import mapProductVariantAttributes from 'utils/mapProductVariantAttributes';
import useSelectColor from 'hooks/products/useSelectColor';
import ColorBox from './ColorBox';
import CarouselArrow from '@/UI/Primitives/CarouselArrow';
import { SliderArrowRight, SliderArrowLeft } from '@/UI/Icons';

const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 500px;
  padding-top: 1rem;
`;

const Arrow = styled.div`
  position: relative;
  right: ${({ prev, next }) => (prev ? '2rem' : next && '0.5rem')};
  cursor: pointer;

  span svg {
    transform: scale(0.4);
  }
`;

const StyledSwiper = styled(Swiper)`
  margin-left: -1.5rem;

  @media (max-width: desktop) {
    display: none;
  }
`;

export default function ColorSlider({ variants }) {
  const swiperRef = useRef(null);

  const colors = variants?.length;

  const { selectedColor, selectColor } = useSelectColor();

  return (
    <SliderContainer>
      {colors > 5 && (
        <Arrow prev>
          <CarouselArrow onClick={() => swiperRef.current.swiper.slidePrev()}>
            <SliderArrowLeft strokeWidth={8} />
          </CarouselArrow>
        </Arrow>
      )}
      {colors > 5 ? (
        <StyledSwiper ref={swiperRef} slidesPerView={5} loop>
          {variants?.map(variant => {
            const { id, sku, image, media_gallery, color, colorUID } =
              mapProductVariantAttributes(variant);
            return (
              <SwiperSlide key={sku}>
                <ColorBox
                  image={image}
                  color={color}
                  selected={selectedColor === sku}
                  onClick={() => selectColor(id, sku, colorUID, media_gallery)}
                />
              </SwiperSlide>
            );
          })}
        </StyledSwiper>
      ) : (
        <Box spaceX="1rem" whiteSpace="nowrap">
          {variants?.map(variant => {
            const { id, sku, image, media_gallery, color, colorUID } =
              mapProductVariantAttributes(variant);
            return (
              <ColorBox
                key={sku}
                image={image}
                color={color}
                selected={selectedColor === sku}
                onClick={() => selectColor(id, sku, colorUID, media_gallery)}
              />
            );
          })}
        </Box>
      )}
      {colors > 5 && (
        <Arrow next>
          <CarouselArrow onClick={() => swiperRef.current.swiper.slideNext()}>
            <SliderArrowRight strokeWidth={8} />
          </CarouselArrow>
        </Arrow>
      )}
    </SliderContainer>
  );
}
